import {Input, message} from 'antd';
import {CopyOutlined} from '@ant-design/icons';
import React from 'react';

import {brandConfig} from '../../../../libs/ui/src';

export function Squid({client}) {
  const link = `${brandConfig.squid_link}?analytics_code=${client.analytics_code}`;
  const copyToClipboard = () => {
    navigator.clipboard.writeText(link);
    message.success('Link copied to clipboard');
  };
  return (
    <div>
      <p>
        To integrate Squid, please copy the URL below and paste it on{' '}
        <a href="https://app.asksquid.ai" target="_blank" rel="noreferrer noopener">
          Squid
        </a>
        {'. Full instructions '}
        <a
          href="https://docs.asksquid.ai/en/article/webhook-1jec6t0/"
          rel="noreferrer noopener"
          target="_blank"
        >
          here
        </a>
        {'.'}
      </p>
      <Input value={link} addonAfter={<CopyOutlined style={{cursor: 'pointer'}} onClick={copyToClipboard} />} />
    </div>
  );
}
